export default __webpack_public_path__ + "static/media/Section_51_Manual.4d947dd7.pdf";